import * as React from 'react';

import resource from '../resources/resource.json';

import Modal from 'react-bootstrap/Modal';

interface IEcommPopupProps
{
    showPopup: boolean;
    callback: any;
    callbackProceed: any;
    locale: string;
    renewableLamps: any[];
    callbackChecked: any;
}

/**
 *
 * Event component
 * @extends {React.PureComponent}
 */
export class Popup extends React.PureComponent<IEcommPopupProps> {
  private formLabels = resource.noOfYearsCategoryNamesForm[this.props.locale];

  public render(): JSX.Element | null {
    return (
      <Modal show={this.props.showPopup} onHide={this._callbackHide} centered>
        <Modal.Header closeButton={false}>
          <Modal.Title className='ecomm-popup-title'>{this._titleText()}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {this._renderMessage()}
          {this.props.renewableLamps.length > 0 && this._renderLampsHeader()}
          {this.props.renewableLamps.length > 0 && this._renderLamps()}
        </Modal.Body>

        <Modal.Footer>
          <a href='' onClick={this._callbackRedirect} className='ecomm-popup-button ecomm-popup-button-go' style={{ width: 100 + '%'}}>{this._goButtonText()}</a>
          {this._renderCancelButton()}
        </Modal.Footer>
      </Modal>
    );
  }

  private _callbackRedirect = () => {
    this.props.callbackProceed();
  }

  private _callbackHide = () => {
    event?.preventDefault();
    this.props.callback();
  }

  private _titleText(): string {
    return this.formLabels.renewDialogTitle;
  }

  private _cancelButtonText(): string {
    return this.formLabels.renewDialogValidCancelTitle;
  }

  private _goButtonText(): string {
    if (this.props.renewableLamps.length > 0) {
      for (let i = 0; i < this.props.renewableLamps.length; i++) {
        if (this.props.renewableLamps[`${i}`]['isChecked'] === false) {
          return this.formLabels.renewDialogProceedTitle;
        }
      }

      return this.formLabels.renewDialogOkayTitle;
    } else {
      return this.formLabels.renewDialogOkayTitle;
    }
  }

  private _renderMessage(): JSX.Element | null {
    if (this.props.renewableLamps.length > 0) {
      for (let i = 0; i < this.props.renewableLamps.length; i++) {
        if (this.props.renewableLamps[`${i}`]['isChecked'] === false) {
          return (
            <div className='ecomm-popup-body'>
              <p>{this.formLabels.renewMessageText}</p>
            </div>
          );
        }
      }

      return (
        <div className='ecomm-popup-body'>
          <p>{this.formLabels.renewSelectedAllMessageText}</p>
        </div>
      );
    }

    return null;
  }

  private _renderLampsHeader(): JSX.Element | null {
    return (
      <div className='ecomm-popup-body'>
        <div className='row'>
          <p className='col-3 ecomm-popup-body-header'>{this.formLabels.renewDialogSerialNoTitle}</p>
          <p className='col-6 ecomm-popup-body-header'>{this.formLabels.renewDialogNameTitle}</p>
          <p className='col-3 ecomm-popup-body-header'>{this.formLabels.renewDialogValidTillTitle}</p>
        </div>
      </div>
    );
  }

  private _renderLamps(): JSX.Element | null {
    return (
      <div className='ecomm-popup-body'>
        {this._renderLampOption()}
      </div>
    );
  }

  private _renderLampOption(): JSX.Element[] | null {
    return this.props.renewableLamps.map((lamp) => {
      const serialNumber = lamp['serialNumber'];
      const serialId = lamp['serialId'];
      const name_1 = lamp['name_1'];
      const name_2 = lamp['name_2'];
      const validTo = lamp['validTo'];
      let isChecked = lamp['isChecked'];

      return (
        <div>
          <label className='lamp-option-group'>
            <input type="checkbox" name="checkbox" value={serialId} onChange={(e) => {
              const checkedLampIndex = this.props.renewableLamps.findIndex((lamp => lamp['serialId'] === e.target.value));
              if (checkedLampIndex >= 0) {
                let updatedSelection = this.props.renewableLamps

                updatedSelection[`${checkedLampIndex}`]['isChecked'] = e.target.checked;
                
                isChecked = e.target.checked;
                
                this.props.callbackChecked(updatedSelection);
              }
            }} checked={isChecked ? isChecked : null} disabled={isChecked ? isChecked : null}/>
            <div className='row lamp-option'>
              <p className='col-3'>{serialNumber}</p>
              <p className='col-6'>{name_1 + (name_2 !== '' ? ' | ' + name_2: '')}</p>
              <p className='col-3'>{validTo}</p>
            </div>
          </label>
        </div>
      );
    })
  }

  private _renderCancelButton(): JSX.Element | null {
    if (this.props.renewableLamps.length > 0) {
      for (let i = 0; i < this.props.renewableLamps.length; i++) {
        if (this.props.renewableLamps[`${i}`]['isChecked'] === false) {
          return (
            <a href='' onClick={this._callbackHide} className='ecomm-popup-button ecomm-popup-button-stay' style={{ width: 100 + '%'}}>{this._cancelButtonText()}</a>
          );
        }
      }

      return null;
    }
    
    return (
      <a href='' onClick={this._callbackHide} className='ecomm-popup-button ecomm-popup-button-stay' style={{ width: 100 + '%'}}>{this._cancelButtonText()}</a>
    );
  }
}

export default Popup;